<template>
  <div style="display: inline-block; overflow: visible">
    <a-popover overlay-class-name="fusion-popover-container" v-if="!showGuide" v-model:visible="questionnaireVisible" trigger="click" placement="bottomLeft">
      <span class="filter-container clickable" :class="{ 'has-searched': hasSearchedList.length }" @click="showFilterPopover">
        <span class="fusion-iconfont icon-filter"></span>
        <span class="filter-text">
          <span v-show="hasSearchedList.length">{{ hasSearchedList.length }}个</span>
          <span>筛选</span>
        </span>
      </span>
      <template #content>
        <div class="popover-content-container">
          <p class="fusion-title"><span>筛选</span></p>
          <FilterList
            class="filter-list-container"
            :source="selfSource"
            v-model:value="filterValue"
            :limitFieldSingle="true"
            :viewId="viewMenuData?.selectedMenu?.id"
            businessType="fusionFilter"
            @change="filterValueChanged"
          />

          <div class="popover-footer">
            <a-button key="reset" @click="handelReset">重置</a-button>
            <a-space>
              <a-button key="back" @click="questionnaireVisible = false">取消</a-button>
              <a-button key="confirm" type="primary" @click="handleOk">确定</a-button>
            </a-space>
          </div>
        </div>
      </template>
    </a-popover>
    <a-popover
      overlay-class-name="guide-popover-container"
      v-if="showGuide"
      v-model:visible="guideVisible"
      trigger="click"
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :autoAdjustOverflow="false"
      @visibleChange="guideVisibleChange"
      placement="bottomLeft"
    >
      <span class="filter-container clickable">
        <span class="fusion-iconfont icon-filter"></span>
        <span class="filter-text">
          <span>筛选</span>
        </span>
      </span>
      <template #content>
        <div class="guide-container">
          <div class="guide-wrap">
            <div class="guide-header-wrap">
              <span class="guide-header-txt">筛选功能全新升级～</span>
              <span class="guide-header-close" @click="closeGuide"></span>
            </div>
            <div class="guide-info"> 更丰富的筛选条件，可满足多种场景使用。 </div>
          </div>
          <div class="guide-content">
            <div class="guide-item">
              <span class="guide-circle"></span>
              <span>可以选择多项内容进行筛选</span>
            </div>
            <div class="guide-item">
              <span class="guide-circle"></span>
              <span>可以添加或删除筛选条件</span>
            </div>
            <div class="guide-item">
              <span class="guide-circle"></span>
              <span>可以与搜索功能同步使用</span>
            </div>
          </div>
          <div class="guide-btn-ok" @click="closeGuide"> 我知道了 </div>
          <img :src="guideImg" alt="" />
        </div>
      </template>
    </a-popover>
    <!--    <div class="screen-bg" v-if="showGuide&&guideVisible"></div>-->
    <template v-if="showSaveView">
      <FilterSaveBtn class="filter-save-btn" :viewMenuData="viewMenuData" />
    </template>
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref, onMounted, watch } from 'vue';
  import { CustomInterface } from './src/config';
  import useInitFilter from './src/hooks/useInitFilter';
  import FilterSaveBtn from './src/components/filterSaveBtn.vue';
  import { emitDoneInitFusionFilterValue, ViewMenuData } from '../ViewMenu/src/config';

  export default defineComponent({
    name: 'FusionFilter',
  });
</script>
<script lang="ts" setup>
  import FilterList from './src/components/filterList.vue';
  import guideImg from '/@/assets/images/guide.png';
  const props = withDefaults(
    defineProps<{
      filterType: string;
      encodeParams?: boolean;
      initialMaxLength?: number;
      customParams?: CustomInterface;
      viewMenuData?: ViewMenuData;
      showSaveView?: boolean;
      filterParams?: Object;
      excludeFields?: string[];
      refreshOnOpen?: boolean;
      disableDefaultValues?: boolean;
    }>(),
    {
      filterType: '',
      encodeParams: true,
      initialMaxLength: 3,
      initialValue: () => [],
      showSaveView: false,
      filterParams: () => ({}),
      excludeFields: () => [],
      refreshOnOpen: false,
      disableDefaultValues: false,
    }
  );

  const emit = defineEmits(['queryFilter', 'resetFilter']);

  const { selfSource, reset, filterValue, getSearchedParams, hasSearchedList, setInitialValue, setCombineRequestParameterMapping, refreshSource } = useInitFilter({
    filterType: props.filterType,
    encodeParams: props.encodeParams,
    initialValue: [],
    initialMaxLength: props.initialMaxLength,
    customParams: props.customParams,
    needLabel: false,
    searchFn: handleOk,
    isShowExtraVacuousList: true,
    excludeFields: props.excludeFields,
    disableDefaultValues: props.disableDefaultValues,
  });
  const questionnaireVisible = ref(false);

  const showGuide = ref(false);
  const guideVisible = ref(false);
  const guideVisibleChange = (visible) => {
    // guideVisible.value = true;
    if (!visible) {
      showGuide.value = false;
    }
  };

  watch(
    () => props.viewMenuData?.selectedMenu,
    () => {
      const filterConfig = props.viewMenuData?.selectedMenu?.viewConfig?.filterConfig ?? [];
      if (filterConfig.length > 0) {
        setInitialValue(filterConfig);
      } else {
        setInitialValue([]);
      }
      handleOk(false);
      emitDoneInitFusionFilterValue();
    }
  );

  const closeGuide = () => {
    guideVisible.value = false;
    showGuide.value = false;
  };
  const initGuide = () => {
    let hasShowedGuide = localStorage.getItem('hasShowedGuide');
    if (hasShowedGuide) {
      showGuide.value = false;
    } else {
      localStorage.setItem('hasShowedGuide', 'yes');
      let nowTime = Date.now();
      // 上线时间 2024年2月29日0点
      // let onlineTime = new Date(2024,0,11).getTime();
      let onlineTime = new Date(2024, 1, 28).getTime();
      // 上线时间大于30天后不展示
      if (nowTime - onlineTime >= 30 * 24 * 3600 * 1000) {
        showGuide.value = false;
      } else {
        showGuide.value = true;
        guideVisible.value = true;
      }
    }
  };

  async function showFilterPopover() {
    questionnaireVisible.value = true;
    if (props.refreshOnOpen) {
      await refreshSource();
    }
  }

  onMounted(() => {
    initGuide();
    props.filterParams && setInitialValue(props.filterParams);
    handleOk(false);
  });

  const handelReset = () => {
    reset();
  };

  function handleOk(isManual = true) {
    const params = getSearchedParams();
    const filterRestoreData = params?.restoreNeedParams?.map?.((item) => {
      const copyedItem = { ...item };
      delete copyedItem.id;
      return copyedItem;
    });

    if (props.viewMenuData) {
      // Existing view-menu integration stores current filter state on the shared menu object.
      // eslint-disable-next-line vue/no-mutating-props
      props.viewMenuData.filterConfig = params?.ruleContentDTO;
      // eslint-disable-next-line vue/no-mutating-props
      props.viewMenuData.restoreConfig = filterRestoreData;
    }
    isManual && emit('queryFilter', params?.ruleContentDTO);
    questionnaireVisible.value = false;
  }

  function filterValueChanged() {
    setCombineRequestParameterMapping();
  }

  const refresh = () => {
    reset();
    handleOk(false);
  };

  const getFilterRestoreData = () => {
    const params = getSearchedParams();
    const filterRestoreData =
      params?.restoreNeedParams?.map?.((item) => {
        const copyedItem = { ...item };
        delete copyedItem.id;
        return copyedItem;
      }) ?? [];
    return filterRestoreData;
  };

  const getFilterDefaultData = () => {
    const params = getSearchedParams();
    return params?.ruleContentDTO;
  };

  defineExpose({
    refresh,
    getFilterRestoreData,
    getFilterDefaultData,
  });
</script>

<style lang="less">
  .fusion-popover-container > .ant-popover-content {
    & > .ant-popover-arrow {
      display: none;
    }
  }
</style>

<style lang="less" scoped>
  @import url('./src/assets/icons/fusion-iconfont.css');
  .filter-container {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    color: #262626;
    height: 32px;
    padding: 5px 12px;

    .filter-text {
      margin-left: 5px;
    }
  }
  .fusion-title {
    color: #999;
    padding: 20px 32px 6px;
    margin-bottom: 0;
  }
  .clickable {
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      color: #2c68ff;
      background-color: #f5f5f5;
    }
  }
  .has-searched {
    background-color: #e2edff !important;
    color: #2c68ff;
  }
  .popover-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e9e9e9;
    padding: 16px 32px 20px;
  }
  .popover-content-container {
    width: 800px;
    margin: -12px -16px;
  }

  .filter-list-container {
    padding: 0 32px 16px;
  }

  // 防止外部代码的屏蔽
  .filter-container :deep(.app-iconify.anticon) {
    display: inline-flex !important;
  }
  :deep(.guide-popover-container) {
    top: 26px !important;
    z-index: 999;
    //transform: translateX(-12px);
  }

  :deep(.guide-popover-container .ant-popover-inner-content) {
    padding: 0;
  }
  :deep(.guide-popover-container .ant-popover-content) {
    box-shadow: none !important;
    padding: 0;
  }
  :deep(.guide-popover-container .ant-popover-content .ant-popover-arrow) {
    display: none;
  }
  :deep(.guide-popover-container .ant-popover-inner) {
    background-color: transparent;
    box-shadow: none;
  }
  .guide-container {
    width: 490px;
    height: auto;
    background: transparent;
    position: relative;
    .guide-wrap {
      width: 100%;
      position: absolute;
      top: 22px;
      padding: 0 16px;
      .guide-header-wrap {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .guide-header-txt {
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          line-height: 22px;
        }
        .guide-header-close {
          width: 24px;
          height: 24px;
          display: inline-block;
          background: transparent;
          cursor: pointer;
        }
      }
      .guide-info {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-top: 12px;
      }
    }
    .guide-content {
      position: absolute;
      top: 126px;
      left: 278px;
      .guide-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 24px;
        .guide-circle {
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #ffffff;
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
    .guide-btn-ok {
      width: 80px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #2c68ff;
      position: absolute;
      right: 16px;
      bottom: 16px;
      cursor: pointer;
    }
  }
  .screen-bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: transparent;
    z-index: 998;
  }
  .filter-save-btn {
    margin-left: 8px;
  }
</style>
